import { getProductCode } from '@/helpers/ProductHelper';
import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInterceptorInstance from './axiosInterceptorInstance';

export const getProductConfigList = createAsyncThunk(
  'productConfig/getProductConfigList',
  async () => {
    try {
      const relativeUrl = 'ProductConfig/GetProductConfigList';
      const apiUrl = `/product/?relativeUrl=${relativeUrl}/${getProductCode()}`;
      const response = await axiosInterceptorInstance.get(apiUrl);
      return response.data;
    } catch (error) {
      return error;
    }
  },
);
